import REGISTER from "../assets/images/register.png";
import Checkbox from "antd/es/checkbox/Checkbox";
import {NavLink, useHistory} from "react-router-dom";
import {useState} from "react";
import $ from 'jquery';
import {toast} from "react-toastify";
import {Eye, EyeOff} from "react-feather";
import API_LINK from "../components/links/Link";
import {Radio, Select} from "antd";
import ReCAPTCHA from "react-google-recaptcha";

export default function ForgotPassword() {
    const [isVisible, setIsVisible] = useState(false)
    const history = useHistory();
    async function submitHandle(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $('.RegisterForm');
        let formdata = new FormData(form[0]);
        let toaster;
        if (!form[0].checkValidity()) {
            toast.warn("Fill all the required(*) fields.")
        } else if (!form.find('input[name="email"]').val().includes("@")) {
            toast.warn("Please enter a valid email address");
        } else {
            form.find("button").attr("disabled", true);
            toaster = toast.loading("Processing...");
            try {
                formdata.append("page", "ForgotPasswordMail");
                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                await fetch(`${API_LINK}Authentication.php`, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        console.log(result);
                        if (result.status === 1) {
                            setTimeout(() => {
                                toast.update(toaster, {
                                    type: "success",
                                    render: "An account reset email has been sent to your provided email address.",
                                    isLoading: false,
                                    autoClose: toaster,
                                    closeButton: true,
                                    pauseOnHover: false,
                                    pauseOnFocusLoss: false,
                                })
                                // toast.info("We have shared a verification email.Please make sure to verify your account.");
                                form.find("button").attr("disabled", false);
                                form.trigger("reset");
                                // history.push("/");
                            }, 1000)
                        } else {
                            toast.error("Server Error! Please try again later.")
                        }
                    })
                    .catch(error => console.log('error', error));
            } catch (e) {
                console.log(e);
            }

        }

    }

    return (
        <>
            <div className='auth-container' style={{justifyContent: "center"}}>
                {/*<div className="auth-image">*/}
                {/*    <img src={REGISTER} loading={"lazy"} alt="Login Image"/>*/}
                {/*</div>*/}
                <div className="auth-form register-form-container" data-aos='fade-left'>
                    <h4 className="title" style={{marginTop: 50, textAlign: "center"}}>Password Reset</h4>
                    <div className="header_text_center">
                        <p style={{fontSize: 14, marginBottom: 30, textAlign: "center"}}>Please enter your email
                            address.
                            You will receive a link to create a new password via email.</p>
                    </div>
                    <form noValidate className='RegisterForm' onSubmit={submitHandle}>
                        <div className="register-form">
                            <div className="form-group">
                                {/*<label>Email address <code>*</code></label>*/}
                                <input type="text" required placeholder={'Email Address*'} name={'email'}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <button type={"submit"} className='btn-login'>Get New Password</button>
                        </div>
                    </form>

                </div>
            </div>
        </>
    )
}
